const typeConstants = {
  STRING: 'string',
  NUMBER: 'number',
  DATE: 'date',
  EMPTY: 'empty',
} as const;

export default typeConstants;
